import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { User } from "../types/user";

@Injectable({
  providedIn: "root",
})
export class AccountService {
 
  
  constructor(private http: HttpClient) { }

  placeApplication(data: any): Observable<any> {
    const RfqUrl = `http://102.210.244.222:9090/api/v1/RFQsApplication/create`;
    return this.http.post<any>(RfqUrl, data);
  }

  getUserById(userId: string): Observable<any> {
    const getUserByIdUrl = `${environment.baseUrl}/api/v1/auth/find/by/appId/${userId}`;
    return this.http.get<User>(getUserByIdUrl);
  }

  getUserByAppId(userId: string): Observable<any> {
    const getUserByIdUrl = `${environment.baseUrl}/api/v1/AppUser/find/by/id/${userId}`;
    return this.http.get<User>(getUserByIdUrl);
  }

  updatePassword(passwordDetails: any): Observable<{ message: string  }> {
    const updatePasswordUrl = `${environment.baseUrl}/api/v1/AppUser/password/change`;
    return this.http.post<{ message: string }>(updatePasswordUrl, passwordDetails);
  }

  getMemberByAppId(params: any): Observable<any> {
    return this.http.get<any[]>(`${environment.baseUrl}/api/v1/auth/find/by/appId/${params}`);
  }

  updateUserPassword(passwordDetails: any): Observable<{ message: string }> {
    const updateUserPasswordUrl = `${environment.baseUrl}/api/v1/AppUser/password/reset`;
    return this.http.post<{ message: string }>(updateUserPasswordUrl, passwordDetails);
  }

  updateProfile(profileBody: any): Observable<{ message: string }> {
    const updatePasswordUrl = `${environment.baseUrl}/p2p/otherusers/updateprofile`;
    return this.http.put<{ message: string }>(updatePasswordUrl, profileBody);
  }


}
